import * as React from "react";
import ArrowRightSvg from "./arrow-right.svg";
import InvoiceSvg from "./invoice.svg";
import ShopFillSvg from "./shop_fill.svg";
import AddressSvg from "./address.svg";
import UserSvg from "./user.svg";
import MoreSvg from "./more_android.svg";
import ArrowLeftSvg from "./arrow-left.svg";
import SuccessSvg from "./success.svg";
import CloseSvg from "./close-bold.svg";
import PlusSvg from "./plus.svg";
import SignOutSvg from "./sign-out.svg";
import BillingSvg from "./billing.svg";
import AngleLeftSvg from "./angle-left.svg";
import AngleDoubleLeftSvg from "./angle-double-left.svg";
import AngleDoubleRightSvg from "./angle-double-right.svg";
import AngleRightSvg from "./angle-right.svg";
interface IconProps{
  width?: number;
  className?:string;
  onClick?: () => void;
}
export const IconArrowRight = (props: IconProps) =>{
  return ( <img {...props} src={ArrowRightSvg} alt={ArrowRightSvg} />)
}
export const IconInvoice = (props: IconProps) =>{
  return ( <img {...props} src={InvoiceSvg} alt={InvoiceSvg} />)
}
export const IconShopFill = (props: IconProps) =>{
  return ( <img {...props} src={ShopFillSvg} alt={ShopFillSvg} />)
}
export const IconAddress = (props: IconProps) =>{
  return ( <img {...props} src={AddressSvg} alt={AddressSvg} />)
}
export const IconUser = (props: IconProps) =>{
  return ( <img {...props} src={UserSvg} alt={UserSvg} />)
}
export const IconMore = (props: IconProps) =>{
  return ( <img {...props} src={MoreSvg} alt={MoreSvg} />)
}
export const IconArrowLeft = (props: IconProps) =>{
  return ( <img {...props} src={ArrowLeftSvg} alt={ArrowLeftSvg} />)
}
export const IconSuccess = (props: IconProps) =>{
  return ( <img {...props} src={SuccessSvg} alt={SuccessSvg} />)
}
export const IconClose = (props: IconProps) =>{
  return ( <img {...props} src={CloseSvg} alt={CloseSvg} />)
}
export const IconPlus = (props: IconProps) =>{
  return ( <img {...props} src={PlusSvg} alt={PlusSvg} />)
}
export const IconSignOut = (props: IconProps) =>{
  return ( <img {...props} src={SignOutSvg} alt={SignOutSvg} />)
}

export const IconBilling = (props: IconProps) =>{
  return ( <img {...props} src={BillingSvg} alt={BillingSvg} />)
}

export const IconAngleLeft = (props: IconProps) =>{
  return ( <img {...props} src={AngleLeftSvg} alt={AngleLeftSvg} />)
}
export const IconAngleRight = (props: IconProps) =>{
  return ( <img {...props} src={AngleRightSvg} alt={AngleRightSvg} />)
}
export const IconAngleDoubleRight = (props: IconProps) =>{
  return ( <img {...props} src={AngleDoubleRightSvg} alt={AngleDoubleRightSvg} />)
}
export const IconAngleDoubleLeft = (props: IconProps) =>{
  return ( <img {...props} src={AngleDoubleLeftSvg} alt={AngleDoubleLeftSvg} />)
}